// Chakra imports
import { Box, Flex, Image } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function AuthIllustration(props: {
  children: JSX.Element;
  illustrationBackground: string;
}) {
  const { children, illustrationBackground } = props;
  
  return (
    <Flex position="relative" h="max-content" minH="100vh">
      <Flex
        h={{
          sm: 'initial',
          md: 'unset',
          lg: '100vh',
          xl: '100vh',
        }}
        w="100%"
        maxW={{ md: '66%', lg: '1313px' }}
        mx="auto"
        pt={{ sm: '50px', md: '0px' }}
        px={{ lg: '30px', xl: '0px' }}
        ps={{ xl: '70px' }}
        justifyContent="center"
        alignItems="flex-start"
        direction="column"
        bg="white"
      >
        {/* Niko Logo */}
        <Box 
          position="absolute" 
          top="40px" 
          left={{ base: '25px', lg: '70px' }}
          zIndex="10"
        >
          <Image 
            src="/LOGO NIKO NEGRO.svg" 
            alt="Niko" 
            h={{ base: '40px', md: '50px', lg: '60px' }}
            w="auto"
          />
        </Box>
        
        {children}
        
        {/* Right side image panel */}
        <Box
          display={{ base: 'none', md: 'block' }}
          h="100%"
          minH="100vh"
          w={{ lg: '50vw', '2xl': '44vw' }}
          position="absolute"
          right="0px"
          bg="gray.50"
          borderBottomLeftRadius={{ lg: '120px', xl: '200px' }}
          overflow="hidden"
        >
          <Flex
            bg={`url(${illustrationBackground})`}
            justify="center"
            align="end"
            w="100%"
            h="100%"
            bgSize="cover"
            bgPosition="center"
            position="absolute"
          />
        </Box>
      </Flex>
    </Flex>
  );
}
// PROPS

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
